import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { BounceLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, User } from "firebase/auth";

import { auth } from "./firebase.config";

interface IContext {
  currentUser: User | null;
}

export const AuthContext = React.createContext<IContext>({ currentUser: null });

interface IProps {
  children: React.ReactNode;
}

export const AuthProvider = ({ children }: IProps) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [pending, setPending] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
        setPending(false);
      } else {
        setCurrentUser(null);
        setPending(false);
      }
    });
  }, [navigate]);

  if (pending) {
    return (
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BounceLoader color="#F1B317" size={120} />
      </Box>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        currentUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
